import * as React from 'react';
import { usePositionSubGroupSTypeGrpLmlDescriptions } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const PositionsSubGroupSTypeGrpLmlDescription = (): JSX.Element => {
  const {
    data,
    isLoading,
    error,
  } = usePositionSubGroupSTypeGrpLmlDescriptions();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
